import {
  AirCfarExerciseFailureEnum,
  type QuoteFailure,
} from "@b2bportal/air-cfar-api";
import { AirCfarExerciseErrorExercised } from "../AirCfarExerciseErrorExercised";
import { AirCfarExerciseErrorExpired } from "../AirCfarExerciseErrorExpired";
import { AirCfarExerciseErrorUnknown } from "../AirCfarExerciseErrorUnknown";
import { AirCfarExerciseErrorVoid } from "../AirCfarExerciseErrorVoid";

export interface AirCfarExerciseErrorQuoteFailureProps {
  data: QuoteFailure;
  termsAndConditionsLink: string;
  goToRegularCancellationFlow: () => void;
  goToPrevScreen: () => void;
  goToContactSupport: () => void;
}

export function AirCfarExerciseErrorQuoteFailure(
  props: AirCfarExerciseErrorQuoteFailureProps
) {
  switch (props.data.failure.AirCfarExerciseFailure) {
    case AirCfarExerciseFailureEnum.Void:
      return (
        <AirCfarExerciseErrorVoid
          termsAndConditionsLink={props.termsAndConditionsLink}
          onContinueClick={props.goToRegularCancellationFlow}
          onGoBackClick={props.goToPrevScreen}
        />
      );
    case AirCfarExerciseFailureEnum.ContractExpired:
      return (
        <AirCfarExerciseErrorExpired
          onGoBackClick={props.goToPrevScreen}
          onContactSupportClick={props.goToContactSupport}
          onContinueClick={props.goToRegularCancellationFlow}
        />
      );
    case AirCfarExerciseFailureEnum.Exercised:
      return (
        <AirCfarExerciseErrorExercised
          onGoBackClick={props.goToPrevScreen}
          onContactSupportClick={props.goToContactSupport}
        />
      );
    default: {
      console.error(
        "AirCfarExerciseErrorQuoteFailure: unknown failure",
        props.data.failure
      );

      return (
        <AirCfarExerciseErrorUnknown
          onGoBackClick={props.goToPrevScreen}
          onContactSupportClick={props.goToContactSupport}
        />
      );
    }
  }
}
